var SERVICES = {
  studio: 'flow-builder',
  library: 'bot-store',
  actiondesk: 'action-desk',
  files: 'files-ui',
  data: 'tables-ui',
  stepbuilder: 'step-builder-ui',
  nlu: 'nlu-ui',
  contacts: 'contacts-ui',
  billing_dashboard: 'billing-dashboard',
  apps: 'apps-ui'
};

export { SERVICES as S };
